import { render, staticRenderFns } from "./image-card.vue?vue&type=template&id=26fd9472"
import script from "./image-card.vue?vue&type=script&lang=js"
export * from "./image-card.vue?vue&type=script&lang=js"
import style0 from "./image-card.vue?vue&type=style&index=0&id=26fd9472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports